import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { CrearProductoComponent } from "./crear-producto/crear-producto.component";
import { CrearProductoDialog } from "./crear-producto/crear-producto-dialog/crear-producto-dialog.component";
import { ProductoComponent } from "./producto/producto.component";
import { EditarProductoDialog } from "./editar-producto/editar-producto-dialog/editar-producto-dialog.component";
import { EliminarProductoDialog } from "./eliminar-producto/eliminar-producto-dialog/eliminar-producto-dialog.component";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { DetalleProductoComponent } from "./detalle-producto/detalle-producto.component";
import { EditarProductoComponent } from "./editar-producto/editar-producto.component";
import { EliminarProductoComponent } from "./eliminar-producto/eliminar-producto.component";
import { RouterModule } from "@angular/router";
import { VerProductosComponent } from "./ver-productos/ver-productos.component";
import { MaterialModule } from "../../components/material/material.module";
import { ArchivoProductoModule } from "./archivos-producto/archivo-producto.module";
import { CaracteristicaModule } from "./caracteristicas/caracteristica.module";
import { ProductoService } from "../../providers/producto.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        MaterialModule,
        ArchivoProductoModule,
        CaracteristicaModule,
    ],
    declarations: [
        CrearProductoComponent,
        CrearProductoDialog,
        ProductoComponent,
        EditarProductoDialog,
        EliminarProductoDialog,
        DetalleProductoComponent,
        EditarProductoComponent,
        EliminarProductoComponent,
        VerProductosComponent
    ],
    providers: [
        ProductoService,
    ],
    entryComponents: [
        CrearProductoDialog,
        EditarProductoDialog,
        EliminarProductoDialog
    ],
    exports: [
        CrearProductoComponent,
        DetalleProductoComponent,
        EditarProductoComponent,
        EliminarProductoComponent,
        ProductoComponent,
        VerProductosComponent,
    ]
})
export class ProductoModule { }